module.exports = __webpack_public_path__ + "static/media/apple_un.328137de.png";